export const ROUTES = {
  HOME: "/",
  ABOUT: "/about",
  SETUP: "/setup",
  ADJUDICATOR: "/adjudicator",
  CURRENT: "/current",
  MC: "/mc",
  CHAIRPERSON: "/chairperson",
  DJ: "/dj",
  FLOOR_MANAGER: "/floor-manager",
  MONITOR: "/monitor",
  LED_SCREEN: "/led",
  BROADCAST_SCREEN: "/broadcast",
  VISUAL_CONTROLLER: "/control",
  // Deep links used by congress QR codes: put the device into training mode and
  // (when a round is given) start the session straight away.
  TRAINING: "/training",
  TRAINING_SYSTEM: "/training/:system",
  TRAINING_ROUND: "/training/:system/:round",
} as const;

export default ROUTES;
type t = typeof ROUTES;
export type RoutesType =  t[keyof t];